import React, { useEffect, useState } from 'react';
import { Monitor, ChevronDown, ChevronUp } from 'lucide-react';
import { capturarInfoTecnica } from '../utils/detectarTech';

/**
 * TechInfoBox — caja plegable con la info técnica auto-capturada + toggle on/off.
 * Controlado: value (objeto o null), onChange; enabled + onToggleEnabled.
 */
export default function TechInfoBox({ value, onChange, enabled, onToggleEnabled }) {
  const [abierto, setAbierto] = useState(false);

  // Al montar: si está activado y aún no hay datos, captúralos y propágalos.
  useEffect(() => {
    if (enabled && !value) onChange(capturarInfoTecnica());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function toggle() {
    const next = !enabled;
    onToggleEnabled(next);
    onChange(next ? capturarInfoTecnica() : null);
  }

  const filas = value
    ? [
        ['Navegador', value.navegador],
        ['Sistema operativo', value.os],
        ['Resolución', value.resolucion],
        ['URL', value.url],
        ['User agent', value.userAgent],
        ['Fecha', value.fecha],
      ]
    : [];

  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 bg-slate-50">
        <button
          type="button"
          onClick={() => enabled && setAbierto((v) => !v)}
          className="flex items-center gap-2 text-sm text-slate-700 min-w-0"
        >
          <Monitor className="w-4 h-4 text-slate-400 shrink-0" />
          <span className="truncate">Información técnica adjunta automáticamente</span>
          {enabled && (abierto ? <ChevronUp className="w-4 h-4 shrink-0" /> : <ChevronDown className="w-4 h-4 shrink-0" />)}
        </button>
        <label className="inline-flex items-center cursor-pointer shrink-0 ml-3">
          <input type="checkbox" checked={enabled} onChange={toggle} className="sr-only peer" />
          <span className="relative w-9 h-5 bg-slate-300 rounded-full peer-checked:bg-primary transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:w-4 after:h-4 after:bg-white after:rounded-full after:transition-all peer-checked:after:translate-x-4" />
        </label>
      </div>

      <div className="px-4 pb-3 pt-1">
        <p className="text-[11px] text-slate-500">
          Esto ayuda a nuestro equipo a resolver más rápido. Puedes desactivarlo si no quieres compartirlo.
        </p>
        {enabled && abierto && (
          <dl className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1.5">
            {filas.map(([k, v]) => (
              <div key={k} className="text-[11px] min-w-0">
                <dt className="text-slate-400">{k}</dt>
                <dd className="text-slate-700 font-mono break-all">{v}</dd>
              </div>
            ))}
          </dl>
        )}
      </div>
    </div>
  );
}
